export default __webpack_public_path__ + "assets/icons/contact-sale.a2206fc5.svg";